import React, { useContext, useEffect, useState } from 'react';

import AuthContext from '../../../services/firebase/AuthContext';
import FireDataContext from '../../../services/firebase/FireDataContext';
import MemberMiniMenu from '../menus/MemberMiniMenu';
import MemberPreferencesContent from './MemberPreferencesContent';

function preference() {
    return {
        location: {
            city: {},
            maxTravelDistance: 50
        }
    }
}

const MemberPreferencesPage = () => {
    const db = useContext(FireDataContext);
    const { currentUser } = useContext(AuthContext);
    const path = `intermediaries/${currentUser.uid}`;
    const [preferences, setPreferences] = useState();

    useEffect(() => {
        db.get({ path }).then(member => {
            if (member) {
                setPreferences(member.preferences || new preference())
            }
            else {
                setPreferences(new preference())
            }
        })
    }, [db, path]);

    const handleChange = fragment => {
        const payload = { preferences: { ...preferences, ...fragment } };
        console.log('preferences payload', payload)

        db.update({
            path,
            payload
        })
        .then(() => {
            setPreferences(payload.preferences);
        })
        .catch(error => console.log(error));
    }

    if (!preferences) return <></>;

    return (
        <MemberMiniMenu>
            <MemberPreferencesContent preferences={preferences} onChange={handleChange} />
        </MemberMiniMenu>
    )
};

export default MemberPreferencesPage;